import Axios from "@/Axios";

class ClientService{

    async getClients(data={}){
        return await Axios.get('wms.wms.api.client.get_clients',{
            params:data
        })
    }
    async createClient(data){
      return await Axios.post('wms.wms.api.client.create_client',data)
    }
    async getClient(client) {
        return await Axios.get('wms.wms.api.client.get_client_by_id', { params: { client: client } })
    }

    async updateClient(data) {
        return await Axios.put(`wms.wms.api.client.update_client`, data)
    }
    async deleteClient(client){
        const client_name = client.map((item) => ({ name: item }))
        return await Axios.delete('wms.wms.api.client.delete_clients',{data:{client_name:client_name}})
    }

}
export default new ClientService()